import { gql } from "@apollo/client";

export const LISTING_INTRO_QUERY = gql`
  query ListingIntro($productType: String!, $metal: String) {
    listingIntro(productType: $productType, metal: $metal) {
      id
      content
      productType
      metal
    }
  }
`;

export const PRODUCT_INTRO_QUERY = gql`
  query ProductIntro($productId: ID!) {
    productIntro(productId: $productId) {
      id
      content
    }
  }
`;

export const ADMIN_LISTING_INTROS_QUERY = gql`
  query AdminListingIntros {
    adminListingIntros {
      id
      pageType
      productType
      metal
      content
      active
      createdAt
    }
  }
`;

export const ADMIN_PRODUCT_INTROS_QUERY = gql`
  query AdminProductIntros {
    adminProductIntros {
      id
      pageType
      productId
      content
      active
      createdAt
    }
  }
`;

export const ADMIN_UPSERT_PAGE_INTRO_MUTATION = gql`
  mutation AdminUpsertPageIntro(
    $id: ID
    $pageType: String!
    $productType: String
    $metal: String
    $productId: ID
    $content: String!
    $active: Boolean
  ) {
    adminUpsertPageIntro(
      input: {
        id: $id
        pageType: $pageType
        productType: $productType
        metal: $metal
        productId: $productId
        content: $content
        active: $active
      }
    ) {
      pageIntro {
        id
        pageType
        productType
        metal
        productId
        content
        active
      }
      errors
    }
  }
`;

export const ADMIN_DELETE_PAGE_INTRO_MUTATION = gql`
  mutation AdminDeletePageIntro($id: ID!) {
    adminDeletePageIntro(input: { id: $id }) {
      success
      errors
    }
  }
`;
